import React, { useEffect } from 'react';
import { Card, CardContent, Typography, useTheme } from '@mui/material';
import { Container, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Get_Important_Marketing_Reports_Action } from '../Redux/Actions/MarketingReports_Action';
import moment from 'moment-timezone';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
} from 'recharts';

export const ImportantMarketingReport = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const mode = theme.palette.mode;
  useEffect(() => {
    dispatch(Get_Important_Marketing_Reports_Action());
  }, [dispatch]);

  const resgetdata = useSelector((state) => state.AllMarketingReports.LeadPreviewmarketingreport);
  const loading = useSelector((state) => state.AllMarketingReports.loading);

  const {
    leadsByChannal = [],
    leadsByStage = [],
    leadsByProject = [],
    campaignSummary = [],
  } = resgetdata || {};

  // Summary Totals
  const totalLeads = campaignSummary.reduce((sum, item) => sum + (item.leadsNumber || 0), 0);
  const totalDeals = campaignSummary.reduce((sum, item) => sum + (item.dealsNumber || 0), 0);
  const totalRevenue = campaignSummary.reduce((sum, item) => sum + (item.totalRevenue || 0), 0);
  const totalCost = campaignSummary.reduce((sum, item) => sum + (item.cost || 0), 0);

  // الحسابات الثانوية
  const totalCPL = totalLeads ? Math.round(totalCost / totalLeads) : 0;
  const totalCPA = totalDeals ? Math.round(totalCost / totalDeals) : 0;
  const totalROI = totalCost ? Math.round(totalRevenue / totalCost) : 0;

  const KpiCard = ({ label, value }) => (
    <Card elevation={1} sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          {label}
        </Typography>
        <Typography variant="h6" fontWeight="bold" color="primary">
          {value.toLocaleString()}
        </Typography>
      </CardContent>
    </Card>
  );
  return (
    <Container className="startpage py-4">
      <h2 className="mb-4" style={{ color: '#102dff' }}>
        Marketing Report
      </h2>

      {loading || !resgetdata ? (
        <div className="text-center my-5">
          <Spinner animation="border" style={{ color: '#102dff' }} />
        </div>
      ) : (
        <>
          {/* Summary KPIs Section */}
          <div className="mb-4">
            <h5 className="mb-3" style={{ color: '#102dff' }}>
              Overall
            </h5>
            <p className="text-muted">Overall Marketing</p>
            <div className="row g-3">
              <div className="col-md-3 col-sm-6">
                <KpiCard label="Deals" value={totalDeals} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="COST" value={totalCost} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="LEADS" value={totalLeads} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="CPL" value={totalCPL} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="CPA" value={totalCPA} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="Revenues" value={totalRevenue} />
              </div>
              <div className="col-md-3 col-sm-6">
                <KpiCard label="ROI" value={totalROI} />
              </div>
            </div>
          </div>
          {/* Charts Row */}
          <div className="row">
            {/* Channels */}
            <div className="col-md-6 mb-4">
              <div
                className="p-3  shadow rounded"
                style={{ background: mode === 'dark' ? '#333' : '#fff' }}
              >
                <h5 style={{ color: '#102dff' }}>Channels</h5>
                <ResponsiveContainer width="100%" height={280}>
                  <BarChart
                    data={leadsByChannal}
                    margin={{ top: 10, right: 30, left: 0, bottom: 10 }}
                    barCategoryGap="20%"
                  >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="channalName" tick={{ fontSize: 12 }} />
                    <YAxis />
                    <Tooltip
                      contentStyle={{ backgroundColor: '#f4f4f4', borderColor: '#102dff' }}
                      cursor={{ fill: '#f0f8ff' }}
                    />
                    <Bar
                      dataKey="totalLeads"
                      fill="#102dff"
                      radius={[10, 10, 0, 0]} // Rounded top corners
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Stages */}
            <div className="col-md-6 mb-4">
              <div
                className="p-3  shadow rounded"
                style={{ background: mode === 'dark' ? '#333' : '#fff' }}
              >
                <h5>Stages</h5>
                <ResponsiveContainer width="100%" height={250}>
                  <LineChart data={leadsByStage}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="stageName" />
                    <YAxis />
                    <Tooltip />
                    <Line type="monotone" dataKey="totalLeads" stroke="#102dff" strokeWidth={2} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* Projects */}
          {/* Projects */}
          <div className="mb-4">
            <div
              className="p-3  shadow rounded"
              style={{ background: mode === 'dark' ? '#333' : '#fff' }}
            >
              <h5 className="mb-3" style={{ color: '#102dff' }}>
                Projects
              </h5>
              <ResponsiveContainer width="100%" height={280}>
                <BarChart
                  data={leadsByProject}
                  margin={{ top: 10, right: 30, left: 0, bottom: 10 }}
                  barCategoryGap="20%"
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="projectName" tick={{ fontSize: 12 }} />
                  <YAxis />
                  <Tooltip
                    contentStyle={{ backgroundColor: '#f4f4f4', borderColor: '#102dff' }}
                    cursor={{ fill: '#f0f8ff' }}
                  />
                  <Bar
                    dataKey="totalLeads"
                    fill="#102dff"
                    radius={[10, 10, 0, 0]} // Rounded top corners
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Campaign Summary Table */}
          <div
            className="p-3 shadow rounded overflow-auto"
            style={{
              background: mode === 'dark' ? '#333' : '#fff',
              color: mode === 'dark' ? '#fff' : '#000',
            }}
          >
            <h5 style={{ color: '#102dff' }}>Campaign Summary</h5>

            <table
              className="table  mt-3"
              style={{
                background: mode === 'dark' ? '#444' : '#fff',
                color: mode === 'dark' ? '#fff' : '#000',
              }}
            >
              <thead
                style={{
                  background: mode === 'dark' ? '#555' : '#f8f9fa',
                  color: mode === 'dark' ? '#fff' : '#000',
                }}
              >
                <tr>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Campaign Name
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Start Date
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Start Time
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    End Date
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    End Time
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Leads
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Deals
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Revenue
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    Cost
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    CPL
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    CPA
                  </th>
                  <th
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#666',
                    }}
                  >
                    ROI
                  </th>
                </tr>
              </thead>

              <tbody>
                {campaignSummary.map((item, index) => (
                  <tr
                    key={item.campaignId}
                    style={{
                      background: mode === 'dark' ? '#333' : '#fff',
                      color: mode === 'dark' ? '#fff' : '#000',
                    }}
                  >
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.campaignName}
                    </td>

                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {moment(item.startDate).tz('Asia/Dubai').format('YYYY-MM-DD')}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {moment(item.startDate).tz('Asia/Dubai').format('hh:mm A')}
                    </td>

                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {moment(item.endDate).tz('Asia/Dubai').format('YYYY-MM-DD')}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {moment(item.endDate).tz('Asia/Dubai').format('hh:mm A')}
                    </td>

                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.leadsNumber}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.dealsNumber}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.totalRevenue}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.cost}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.cpl}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.cpa}
                    </td>
                    <td
                      style={{
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#333',
                      }}
                    >
                      {item.roi}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </Container>
  );
};
